import { cn } from "@/domains/library"
import { TokenStore } from "@/domains/tokens"

export const DisplayTokenRow = ({
  token,
  amount,
  justify = "end",
}: {
  token: TokenStore
  amount: bigint
  justify?: "start" | "end"
}) => {
  return (
    <div className={cn("flex gap-1", justify === "end" ? "justify-end" : "justify-start")}>
      <span className="text-t100">{token.displayUnits(amount, 4)}</span>
      <span className="text-t200">{token.symbol}</span>
      <img src={token.imageURL} alt={token.symbol} className="h-4 w-4" />
    </div>
  )
}
